import React from 'react';

const Header = () => {
  return (
    <div className='header'>Keep a track of your daily objectives...</div>
  )
}

export default Header